import React from "react";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import HeroSection from "../../components/HeroSection/HeroSection";
import HeroCaption from "../../components/HeroCaption/HeroCaption";
import CourseInfoResponsive from "../../components/CourseInfoResponsive/CourseInfoResponsive";
import FacultyResponsive from "../../components/FacultyResponsive/FacultyResponsive";
import CoursesResponsive from "../../components/CoursesResponsive/CoursesResponsive";
import PublicationResponsive from "../../components/PublicationResponsive/PublicationResponsive";
import ResearchInfoResponsive from "../../components/ResearchInfoResponsive/ResearchInfoResponsive";
import ResearchContentResponsive from "../../components/ResearchContentResponsive/ResearchContentResponsive";

const ResearchPage = () => {
	return (
		<PageWrapper className="mt-n6">
			<HeroSection className="bg-page-background-7">
				<HeroCaption
					title="Research at NIET"
					position="bottom-left"
					breadcrumb={true}
					breadcrumbPrefix="Home"
				/>
			</HeroSection>
			<ResearchInfoResponsive />
			<ResearchContentResponsive/>
			<PublicationResponsive />
			{/* <FacultyResponsive /> */}
			{/* <CoursesResponsive /> */}
		</PageWrapper>
	);
};

export default ResearchPage;
